import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/lib/auth";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const ran = useRef(false);
  const [error, setError] = useState("");

  useEffect(() => {
    if (ran.current) return;
    ran.current = true;
    const hash = window.location.hash || "";
    const m = hash.match(/session_id=([^&]+)/);
    if (!m) {
      setError("Missing session id");
      return;
    }
    const session_id = decodeURIComponent(m[1]);
    (async () => {
      try {
        const { data } = await api.post("/auth/session", { session_id });
        setUser(data);
        // Clear hash and redirect
        window.history.replaceState(null, "", window.location.pathname);
        if (data.role === "admin") navigate("/admin", { replace: true, state: { user: data } });
        else navigate("/dashboard", { replace: true, state: { user: data } });
      } catch (e) {
        const detail = e?.response?.data?.detail || "Sign-in failed";
        setError(detail);
      }
    })();
  }, [navigate, setUser]);

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-atf-bg px-6 text-center">
      {error ? (
        <div className="max-w-md anim-fade-up">
          <div className="eyebrow text-atf-negative mb-3">Access denied</div>
          <p className="font-serif text-3xl text-atf-brand mb-4">{error}</p>
          <button
            onClick={() => (window.location.href = "/login")}
            data-testid="back-to-login"
            className="border border-atf-border px-5 py-2.5 text-xs uppercase tracking-[0.18em] font-semibold hover:bg-atf-subtle"
          >
            Back to sign in
          </button>
        </div>
      ) : (
        <>
          <div className="eyebrow mb-3">Authenticating</div>
          <div className="font-serif text-3xl text-atf-brand">Establishing your session…</div>
        </>
      )}
    </div>
  );
}
